module.exports = __webpack_public_path__ + "img/bg3-2.dc04d5de.png";